module.exports = __webpack_public_path__ + "static/img/E1.db193eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/E1.png
// module id = WTN7
// module chunks = 0